// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"headline-desc_wrapper__23M0N"};